import RpcService  from '@/core/services/Rpc/RpcService';
import RpcResponse from '@/core/services/Rpc/RpcResponse';
import RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import RpcDataSort from "@/core/services/Rpc/RpcDataSort";

class ProductCategoriesDAO {

	static getList(
    filters?: {
      parentId?: number,
      pattern?: string,
      name?: string,
      showUnpublished?: boolean,
      isLeaf?: boolean,
      isBookmarked?: boolean,
      requireAllowedUnits?: boolean,
      requireCharacteristics?: boolean,
    },
    pagination?: RpcDataPagination,
    sort?: RpcDataSort,
  ): Promise<RpcResponse> {
		return RpcService.makeRequest(
      'productCategories.getList',
      filters,
      pagination,
      sort
    );
	}

	static get(id: number | string, options?: {
		requireAllowedUnits?: boolean;
		requireCharacteristics?: boolean;
	}): Promise<RpcResponse> {
		return RpcService.makeRequest('productCategories.get', {
			id,
			...(options ?? {}),
		});
	}

	static add(productCategory: any): Promise<RpcResponse> {
		return RpcService.makeRequest('productCategories.add', { productCategory });
	}

	static update(productCategory: any): Promise<RpcResponse> {
		return RpcService.makeRequest('productCategories.update', { productCategory });
	}

	static delete(id: number): Promise<RpcResponse> {
		return RpcService.makeRequest('productCategories.delete', { id });
	}

	static getPath(productCategoryId: number): Promise<RpcResponse> {
		return RpcService.makeRequest('productCategories.getPath', { productCategoryId });
	}

	static attachCharacteristic(productCategoryId: number, characteristicId: number): Promise<RpcResponse> {
		return RpcService.makeRequest('productCategories.attachCharacteristic', {
			productCategoryId,
			characteristicId,
		});
	}

	static detachCharacteristic(productCategoryId: number, characteristicId: number): Promise<RpcResponse> {
		return RpcService.makeRequest('productCategories.detachCharacteristic', {
			productCategoryId,
			characteristicId,
		});
	}

	static updateCharacteristicRequired(productCategoryId: number, characteristicId: number, isRequired: boolean): Promise<RpcResponse> {
		return RpcService.makeRequest('characteristics.isRequiredUpdate', {
			productCategoryId,
			characteristicId,
			isRequired,
		});
	}

	static attachAllowedUnit(productCategoryId: number, unitId: number): Promise<RpcResponse> {
		return RpcService.makeRequest('productCategories.attachAllowedUnit', {
			productCategoryId,
			unitId,
		});
	}

	static detachAllowedUnit(productCategoryId: number, unitId: number): Promise<RpcResponse> {
		return RpcService.makeRequest('productCategories.detachAllowedUnit', {
			productCategoryId,
			unitId,
		});
	}
}

export default ProductCategoriesDAO;
